import { useMenuContext } from '@ariakit/react/menu';
import { useState } from 'react';
import { trackError } from '#api/errors.ts';
import { useTimeout } from '#hooks/useTimeout.ts';
import { copyToClipboard } from '#util/copy-to-clipboard.ts';
import { MenuItem } from './index.ts';

type Props = {
  id: string;
};

/**
 * {@link CopyIDMenuItem} copies `id` and keeps the menu open long enough to show "Copied!",
 * since closing on click would hide the only confirmation the copy happened.
 */
export function CopyIDMenuItem({ id }: Props) {
  const menu = useMenuContext();
  const [label, setLabel] = useState<'Copy ID' | 'Copied!' | 'Unable to copy'>('Copy ID');

  const { start: hideAfterDelay } = useTimeout(() => {
    menu?.hide();
  }, 1000);

  return (
    <MenuItem
      hideOnClick={false}
      onClick={() => {
        copyToClipboard(id)
          .then(() => {
            setLabel('Copied!');
            hideAfterDelay();
            return;
          })
          .catch((err: unknown) => {
            setLabel('Unable to copy');
            trackError(err);
          });
      }}
    >
      {label}
    </MenuItem>
  );
}
